import "./App.css";
import RouteConfig from "./routes";

function App() {
  return <RouteConfig />;
}

export default App;
